import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class PhotoItemPrice extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): PhotoItemPrice {
    return new PhotoItemPrice(value);
  }

  /** キー */
  static get key(): string {
    return 'photoItemPrice';
  }

  /** タイプ */
  static get type(): string {
    return 'number';
  }

  /** ラベル */
  static get label(): string {
    return '価格（円、税込み）';
  }

  /** プレースホルダー */
  static get placeholder(): number {
    return 110;
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value.toString();
  }
}
